// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__W+4Sb","name":"header_name__YmzYq","menu":"header_menu__+Iikr","menuItem":"header_menuItem__dHEEk"};